import api from "@/api/url";

export default {
    namespaced: true,

    state: () => {
        return {
            twoFactorAuth: {
                authenticatorApp: {},
                sms: {},
            },
            general: {
                language: "en-US",
                timeZone: "",
                timeFormat: "12h",
                dateFormat: "DD/MMMM/YYYY",
                dayOfWeek: "sunday",
                currency: "usd",
                nameDisplay: {
                    payments: "legal",
                    public_profile: "legal",
                    comms: "legal",
                },
            },
            appearance: {
                theme: "default",
            },
            notifications: [],
            goalId: "",
            isGoalsEnabled: false,
            isProductivityEnabled: false,
            goals: [],
            productivity: {
                status: "",
                workingDays: [],
            },
        };
    },

    getters: {
        twoFactorAuth: state => state.twoFactorAuth,
        general: state => state.general,
        appearance: state => state.appearance,
        goals: state => state.goals,
        isGoalsEnabled: state => state.isGoalsEnabled,
        notifications: state => state.notifications,
        isProductivityEnabled: state => state.isProductivityEnabled,
        productivity: state => state.productivity,
    },

    mutations: {
        set(state, [key, value]) {
            state[key] = value;
        },
    },
    
    actions: {
        // USER SETTINGS ---------------------------
        setCurrency({ commit, state }, payload) {
            commit("set", ["general", {
                ...state.general,
                currency: payload?.currency,
            }]);
        },

        fetchSettings({ commit, state }, { refresh }) {
            if (!refresh) {
                return state.userSettings;
            }

            return api.settings.getSettings()
                .then((res) => {
                    const data = res.data.data;                    
                    commit("set", ["twoFactorAuth", data.twoFactorAuth]);
                    commit("set", ["general", data.general]);
                    commit("set", ["appearance", data.appearance]);
                });
        },

        updateGeneralSettings({ state, commit }, payload) {
            return api.settings.updateSettings(payload)
                .then((resp) => {
                    const data = resp.data.data;  
                                        
                    commit("set", ["general", {
                        ...state.general,
                        ...data.general,
                        ...data.appearance,
                    }]);
                });
        },

        fetchNotifications({ commit, state }, { refresh }) {
            if (state.notifications?.length && !refresh) {
                return state.notifications;
            }

            return api.settings.getNotifications()
                .then((res) => {
                    const data = res.data.data;
                    commit("set", ["notifications", data]);
                    return data;
                });
        },

        updateNotifications({ state, commit }, payload) {
            return api.settings.updateNotifications(payload)
                .then((resp) => {                    
                    commit("set", ["notifications", payload]);
                });
        },

        enableTwoFA(_) {},

        fetchGoals({ commit }) {
            return api.settings.getGoals()
                .then((res) => {
                    const data = res.data.data;
                    commit("set", ["goals", data.goals]);
                    commit("set", ["isGoalsEnabled", data.isGoalsEnabled]);
                    commit("set", ["isProductivityEnabled", data.isProductivityEnabled]);
                    commit("set", ["productivity", data.productivity]);                   
                    commit("set", ["goalId", data._id]);                    
                    return data;
                });
        },

        updateGoals({ commit }, payload) {
            return api.settings.updateGoals(payload)
                .then((resp) => {                    
                    commit("set", ["goals", payload.goals]);
                    commit("set", ["isGoalsEnabled", payload.isGoalsEnabled]);
                    commit("set", ["isProductivityEnabled", payload.isProductivityEnabled]);
                    commit("set", ["productivity", payload.productivity]);                   
                    commit("set", ["goalId", payload._id]);           
                });
        },

        fetchCalendar({ state, commit }) {
            if (state.calendarData) {
                return state.calendarData;
            }

            return api.settings.getCalendar()
                .then((res) => {
                    const data = res.data.data;
                    commit("set", ["calendarData", data]);
                });
        },

        updatePassword(_, payload) {
            return api.user.changePassword(payload)
                .then((res) => {});
        },
    },
};